import { SCHEMA_SQL } from './schema';
export function parseSchemaMap() {
    const map = {};
    const tableRegex = /CREATE TABLE (\w+)\s*\(([\s\S]*?)\);/g;
    let match;
    while ((match = tableRegex.exec(SCHEMA_SQL)) !== null) {
        const tableName = match[1];
        const body = match[2];
        const columns = [];
        for (const line of body.split('\n')) {
            const trimmed = line.trim();
            if (!trimmed || trimmed.startsWith('FOREIGN KEY') || trimmed.startsWith(')'))
                continue;
            const colMatch = trimmed.match(/^(\w+)\s+/);
            if (colMatch) {
                columns.push(colMatch[1]);
            }
        }
        map[tableName] = columns;
    }
    return map;
}
export function parseSchemaDetails() {
    const tables = [];
    const tableRegex = /CREATE TABLE (\w+)\s*\(([\s\S]*?)\);/g;
    let match;
    while ((match = tableRegex.exec(SCHEMA_SQL)) !== null) {
        const tableName = match[1];
        const body = match[2];
        const columns = [];
        for (const line of body.split('\n')) {
            const trimmed = line.trim().replace(/,$/, '');
            if (!trimmed || trimmed.startsWith('FOREIGN KEY') || trimmed.startsWith(')'))
                continue;
            const colMatch = trimmed.match(/^(\w+)\s+([\w()' ]+?)(?:\s+(NOT NULL|PRIMARY KEY|UNIQUE|DEFAULT .+).*)?$/i);
            if (colMatch) {
                columns.push({
                    name: colMatch[1],
                    type: colMatch[2].trim(),
                    constraints: colMatch[3]?.trim() ?? '',
                });
            }
        }
        tables.push({ name: tableName, columns });
    }
    return tables;
}
